export default __webpack_public_path__ + "images/f3f39d57dafd6c5c6dd46ad236c06431.svg";